import { render, staticRenderFns } from "./createModal.vue?vue&type=template&id=0926cfe0&scoped=true&"
import script from "./createModal.vue?vue&type=script&lang=js&"
export * from "./createModal.vue?vue&type=script&lang=js&"
import style0 from "./createModal.vue?vue&type=style&index=0&id=0926cfe0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0926cfe0",
  null
  
)

export default component.exports